import React, { useEffect, useState } from 'react'
import { listMedidas, tryError } from '../../../../services/Afins'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import {
  delInsumos,
  getInsumos,
  InsumosItens,
  postInsumos,
  putInsumos,
  TypeInsumos,
} from '../../../../services/recomendacao/insumos'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'
import ViewPage from '../../../../Components/ViewPage'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import { AxiosResponse } from 'axios'
import { Drawer } from 'antd'
import ButtonCustom from '../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import { getRecomendaAtivos, TypeRecomendaAtivos } from '../../../../services/recomendacao/ativos'
import { v4 as uid } from 'uuid'
import {
  getCategoriaInsumo,
  getCategoriaProdutos,
  TypeCategoriaProdutos,
} from '../../../../services/categoriaProdutos'
import { getCategoriaMarcaInsumo } from '../../../../services/config/marca'
import { getFormulacao, TypeFormulacao } from '../../../../services/recomendacao/formulacao'
import FormInsumoNovo, { TypeInsetAtivos } from './components/formulario'
import { TypeEditAlvo } from '../../../../Components/recomendacao/insumos'
import { ContainerInsumos } from './styled'
import { TabelaInsumos } from './components/tabela'

const CatalogoDefensivos: React.FC = () => {
  const [visibleForm, setVisibleForm] = useState(false)
  const [update, setUpdate] = useState(0)

  const [dataInsumos, setDataInsumos] = useState<InsumosItens[]>([])
  const [tempInsumos, setTempInsumos] = useState([])

  const [totalInsumos, setTotalInsumos] = useState(0)

  const [permissions, setPermissions] = useState<ItensPerUserLogged>()

  const [loadingTable, setLoadingTable] = useState(false)

  const [clone, setClone] = useState(0)

  const [searchValue, setSearchValue] = useState('')

  //TABELA
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState(null)
  const [buscarTabela, setBuscarTabela] = useState('')
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //FORMULARIO
  const [tab_selecionar_atual, setTab_selecionar_atual] = useState<
    'Dados do insumo' | 'Composição' | 'Aplicação'
  >('Dados do insumo')
  const [loadingForm, setLoadingForm] = useState(false)

  const [nome, setNome] = useState('')
  const [categoria, setCategoria] = useState<string>('')
  const [categoriaId, setCategoriaId] = useState<number>(null)
  const [classeAgro, setClasseAgro] = useState<string>('')
  const [classeAgroId, setClasseAgroId] = useState<number>(null)
  const [fabricante, setFabricante] = useState<string>('')
  const [fabricanteId, setFabricanteId] = useState<number>(null)
  const [formulacao, setFormulacao] = useState<string>('')
  const [formulacaoId, setFormulacaoId] = useState<number>(null)
  const [unidadeDose, setUnidadeDose] = useState<string>('')
  const [unidadeDoseId, setUnidadeDoseId] = useState<number>(null)
  const [observacao, setObservacao] = useState<string>('')
  const [ativo, setAtivo] = useState<string>('')
  const [ativosId, setAtivosId] = useState<number>(null)
  const [ativos, setAtivos] = useState<TypeInsetAtivos[]>([] as TypeInsetAtivos[])
  const [concentracao, setConcentracao] = useState<string>('')
  const [cultura, setCultura] = useState<string>('')
  const [culturaId, setCulturaId] = useState<number>(null)
  const [faseDeCultura, setFaseDeCultura] = useState<string>('')
  const [faseDeCulturaId, setFaseDeCulturaId] = useState<number>(null)
  const [aplicacoes, setAplicacoes] = useState<InsumosItens['aplicacoes']>(
    [] as InsumosItens['aplicacoes']
  )
  const [especie, setEspecie] = useState<string>('')
  const [especieId, setEspecieId] = useState<number>(null)
  const [variacaoEspecie, setVariacaoEspecie] = useState<string>('')
  const [variacaoEspecieId, setVariacaoEspecieId] = useState<number>(null)
  const [doseBula, setDoseBula] = useState<string>('')
  const [doseUsual, setDoseUsual] = useState<string>('')
  const [addEspecieAplicacoes, setAddEspecieAplicacoes] = useState([])
  const [alvoSelect, setAlvoSelect] = useState(0)
  const [dataCatProduto, setDataCatProduto] = useState([])
  const [dataAtivos, setDataAtivos] = useState([])
  const [dataCatCategoria, setDataCatCategoria] = useState([])
  const [dataFabricantes, setDataFabricantes] = useState([])
  const [dataFormulacao, setDataFormulacao] = useState([])
  const [dataUnidadeMedida, setDataUnidadeMedida] = useState([])
  const [doseBulaUpdate, setDoseBulaUpdate] = useState('')
  const [doseUsualUpdate, setDoseUsualUpdate] = useState('')

  //   setLoadingTable(true)
  //   const quantidadeDesejada = 10;
  //   const resp: AxiosResponse<TypeInsumos> = await getInsumos({
  //     embed: 'composicao,aplicacoes',
  //     pagination: quantidadeDesejada,
  //   })

  //   setDataInsumos(resp.data.itens)
  //   setTempInsumos(resp.data.itens)
  //   setLoadingTable(false)
  // }

  const listInsumos = async () => {
    setLoadingTable(true)

    const resp: AxiosResponse<TypeInsumos> = await getInsumos({
      embed: 'composicao,aplicacoes',
      pagination: pagination,
      page: page,
      nome: buscarTabela !== '' ? buscarTabela : undefined,
      codCategoriaProduto: 1
    })
    setDataInsumos(resp.data.itens)
    setTempInsumos(resp.data.itens)
    setTotal(resp.data.total)
    setLoadingTable(false)
  }

  // const handlePageChange = (page) => {
  //   setCurrentPage(page)
  //   listInsumos(page)
  // }

  // const handlePageSizeChange = (size) => {
  //   setDataInsumos([])

  //   setPageSize(size)
  //   setCurrentPage(1)

  //   listInsumos(1, size)
  // }

  // Objeto para armazenar os dados das páginas
  const pageData = {}

  // const getInsumoPage = async (page: number, pagination?: number) => {
  //   setLoadingTable(true)
  //   const resp = await getInsumos({
  //     embed: 'composicao,aplicacoes',
  //     pagination: pagination,
  //     page: page,
  //     nome: searchValue,
  //   })

  //   const dados = resp.data.itens

  //   const arrayObjectInsumos = (insumo) => ({ ...insumo, [page]: dados })

  //   setDataInsumos(arrayObjectInsumos)

  //   // Calcula o número total de páginas necessárias

  //   setTotal(resp.data.total)
  //   setTotalInsumos(resp.data.itens.length)
  //   setLoadingTable(false)

  //   return dados
  // }

  // const listInsumos = async (page = 1, pagination = pagination) => {
  //   const insumos = await getInsumoPage(page, pagination)

  //   setTotalInsumos(insumos.length)
  //   setTempInsumos(insumos)
  //   setCurrentPage(page)
  //   setLoadingTable(false)
  // }

  const abrir = () => {
    setVisibleForm(true)
  }

  const handleClickEdit = (cod) => {
    setUpdate(cod)
    setVisibleForm(true)
  }

  function fecharGaveta() {
    setVisibleForm(false)
    setUpdate(null)
    setClone(null)
    setTab_selecionar_atual('Dados do insumo')
    setNome('')
    setCategoria('')
    setCategoriaId(null)
    setClasseAgro('')
    setClasseAgroId(null)
    setFabricante('')
    setFabricanteId(null)
    setFormulacao('')
    setFormulacaoId(null)
    setUnidadeDose('')
    setUnidadeDoseId(null)
    setObservacao('')
    setAtivo('')
    setAtivosId(null)
    setConcentracao('')
    setAtivos([])
    setCultura('')
    setCulturaId(null)
    setFaseDeCultura('')
    setFaseDeCulturaId(null)
    setEspecie('')
    setEspecieId(null)
    setVariacaoEspecie('')
    setVariacaoEspecieId(null)
    setDoseBula('')
    setDoseBulaUpdate('')
    setDoseUsual('')
    setDoseUsualUpdate('')
    setAplicacoes([])
  }

  const handleClickClone = (cod) => {
    setClone(cod)
    setVisibleForm(true)
  }

  const handleChangeClasse = async (codCategoriaProduto) => {
    setClasseAgroId(codCategoriaProduto)
    const resp: AxiosResponse<TypeRecomendaAtivos> = await getRecomendaAtivos({
      codCategoriaProduto,
      pagination: -1,
    })

    const catego = dataCatProduto.find((data) => codCategoriaProduto === data.cod)
    if (catego?.cod_categoria === 10) {
    }

    setDataAtivos(resp.data.itens)
  }
  console.log('doses', doseBulaUpdate, doseUsualUpdate)
  const updateAlvo = async (codEspecie, codVariacao, i, codAplicacao, index, cod, dados) => {
    const aplica = JSON.parse(JSON.stringify(aplicacoes))
    setDoseBulaUpdate(dados?.dose_bula)
    setDoseUsualUpdate(dados?.dose_usual)
    const fields: TypeEditAlvo = {
      cod,
      dose_bula: Number(`${String(doseBulaUpdate)?.replace(',', '.')}`),
      dose_usual: Number(`${String(doseUsualUpdate)?.replace(',', '.')}`),
      // medida: form.getFieldValue(`medida${alvoSelect}`),
      cod_especie: codEspecie,
      cod_variacao_especie: codVariacao,
    }

    if (update > 0) {
      loadingAlert({ msg: 'Salvando alterações...', id: 'save_alter' })
      const resp: AxiosResponse<TypeInsumos> = await putInsumos(
        update,
        {
          aplicacoes: [
            {
              cod: codAplicacao,
              alvos: [fields],
            },
          ],
        },
        { embed: 'aplicacoes,alvos,composicao' }
      )

      if (resp?.status === 200 || resp?.status === 204) {
        successAlert('Alvo atualizado com sucesso!', 5000, 'save_alter')

        editInsumo(resp.data.itens[0].cod)
        setAlvoSelect(0)
      }

      if (resp?.status === 400) {
        errorAlert('Falha na operação!', 5000, 'save_alter')
      }
    } else {
      aplica[index].alvos[i] = fields
      setAplicacoes(aplica)
      destroyAlert('save_alter')
    }
    setDoseBulaUpdate('')
    setDoseUsualUpdate('')
    destroyAlert('save_alter')
  }

  const removeAlvo = async (cod, codAplicacao, index: number) => {
    if (typeof cod === 'string') {
      setAplicacoes((prev) =>
        prev.map((item) => ({
          ...item,
          alvos: item.alvos.filter((u) => u.cod !== cod),
        }))
      )
    } else {
      try {
        const remove = () => {
          const dados = [...aplicacoes]
          dados.map((data) => {
            if (data.cod === codAplicacao) {
              data.alvos = data.alvos.filter((alvo) => alvo.cod !== cod)
            }
            return data
          })
          successAlert('Alvo removido com sucesso!')
          setAplicacoes(dados)
        }

        if (update === 0) {
          remove()
        } else {
          loadingAlert({ msg: 'Removendo...', id: 'remove_2' })
          const resp = await putInsumos(
            update,
            {
              aplicacoes: [
                {
                  cod: codAplicacao,
                  alvos_remover: [cod],
                },
              ],
            },
            { embed: 'aplicacoes,alvos,composicao' }
          )

          if (resp.status === 200) {
            remove()
            destroyAlert('remove_2')
          }

          if (resp.status === 400) {
            destroyAlert('remove_2')
          }
        }
      } catch (error) {
        tryError(error)
        destroyAlert('remove_2')
      }
    }
  }

  const editInsumo = async (cod) => {
    setLoadingForm(true)
    loadingAlert({ msg: 'Carregando insumo...', id: 'load_ativos' })
    const resp: AxiosResponse<TypeInsumos> = await getInsumos({
      cod,
      embed: 'aplicacoes,alvos,composicao',
    })

    const dados = resp.data.itens[0]

    handleChangeClasse(dados.cod_categoria_produto)

    let composicao: TypeInsetAtivos[] = []

    dados.composicao.forEach((data) => {
      composicao = [
        ...composicao,
        {
          uid: uid(),
          cod: data.cod,
          concentracao: data.concentracao,
          cod_ativo: data.cod_ativo,
          nomeAtivo: data.ativo_nome,
        },
      ]
    })

    const aplica = dados.aplicacoes.map((rec) => {
      if (clone > 0) {
        rec.cod = uid()
      }

      rec.alvos.map((item) => {
        if (clone > 0) {
          item.cod = uid()
        }
        item.cod_cultura = rec.cod_cultura
        return item
      })
      return rec
    })

    const formulacao_nome = dataFormulacao?.filter((item) => item?.cod === dados?.cod_formulacao)
    const medida_aplicacao_nome = dataUnidadeMedida?.filter(
      (rec) => rec?.cod === dados?.cod_medida_aplicacao
    )

    setAplicacoes(aplica)
    setAtivos(composicao)
    setNome(dados.nome)
    setCategoria(dados.categoria_produto_nome)
    setCategoriaId(dados.cod_categoria_produto)
    setClasseAgro(dados.classe_agronomica_nome)
    setClasseAgroId(dados.cod_classe_agronomica)
    setFabricante(dados.fabricante_nome)
    setFabricanteId(dados.cod_fabricante)
    setFormulacao(formulacao_nome[0]?.nome)
    setFormulacaoId(dados.cod_formulacao)
    setUnidadeDose(medida_aplicacao_nome[0]?.nome)
    setUnidadeDoseId(dados.cod_medida_aplicacao)
    setObservacao(dados.observacao)

    destroyAlert('load_ativos')
    setLoadingForm(false)
  }

  const adicionarAtivos = async () => {
    const nomeAtivo = dataAtivos.find((data) => data.cod === ativosId)

    const check = ativos.find((data) => data.cod_ativo === ativosId)

    if (check !== undefined) {
      errorAlert('Ativo já inserido!')

      return
    }

    setAtivos([
      ...ativos,
      {
        uid: uid(),
        cod: null,
        cod_ativo: ativosId,
        nomeAtivo: nomeAtivo.nome,
        concentracao: Number(concentracao.replace(',', '.')),
      },
    ])
    if (update > 0) {
    }
    setAtivo('')
    setConcentracao('')
  }

  const salvarInsumos = async () => {
    const dataAtivos = [...ativos]
    // eslint-disable-next-line camelcase
    let tempAtivo: { cod_ativo: number; concentracao: number }[] = []
    dataAtivos.forEach((ativo) => {
      tempAtivo = [
        ...tempAtivo,
        {
          cod_ativo: ativo.cod_ativo,
          concentracao: ativo.concentracao,
        },
      ]
      return tempAtivo
    })

    let dataFim: InsumosItens = {
      nome: nome,
      cod_fabricante: fabricanteId,
      cod_categoria_produto: 1,
      cod_classe_agronomica: classeAgroId,
      cod_formulacao: formulacaoId,
      adjuvante: undefined,
      cod_medida_aplicacao: unidadeDoseId,
      observacao: observacao,
      // @ts-ignore
      ativos: tempAtivo,
      aplicacoes,
    }

    // if (data.adjuvante === 1) {
    //   dataFim = { ...dataFim, cod_tipo_adjuvante: data.cod_tipo_adjuvante }
    // }

    try {
      loadingAlert({ msg: 'Salvando...', id: 'save_ativo' })
      if (update <= 0 || clone > 0) {
        const resp = await postInsumos(dataFim)

        if (resp.status === 201) {
          successAlert('Insumo salvo com sucesso!', 5000, 'save_ativo')
          fecharGaveta()
          setAtivos([] as TypeInsetAtivos[])
          setAplicacoes([])
          setTab_selecionar_atual('Dados do insumo')
          listInsumos()
        }
      } else {
        const resp = await putInsumos(update, dataFim)

        if (resp.status === 200) {
          successAlert('Insumo atualizado com sucesso!', 5000, 'save_ativo')

          editInsumo(resp.data.itens[0].cod)
          fecharGaveta()
          listInsumos()
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha na operação!', 7000, 'save_ativo')
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha na operação!', 7000, 'save_ativo')
          })
        }
      } else {
        errorAlert('Falha na operação! (sem resposta)', 7000, 'save_ativo')
      }
    }
  }

  const deletarInsumo = async (cod) => {
    setFake_loading(true)
    try {
      const response = await delInsumos(cod)

      if (response.status === 200) {
        successAlert('Insumo removido com sucesso!')

        listInsumos()
      }
      setTimeout(() => {
        setFake_loading(false)
      }, 500)
    } catch (error) {
      tryError(error)
      setFake_loading(false)
    }
  }

  const handleRemoveAtivo = async (uid, cod = null) => {
    const dados = [...ativos]
    let filtro = []
    if (cod === null) {
      filtro = dados.filter((data) => data.uid !== uid)
    } else {
      loadingAlert({ msg: 'Removendo...', id: 'remove_ativo' })
      const resp = await putInsumos(update, {
        ativos_remover: [cod],
      })
      if (resp?.status === 200 || resp?.status === 204) {
        filtro = dados.filter((data) => data.uid !== uid)

        successAlert('Ativo removido com sucesso!', 5000, 'remove_ativo')
      } else {
        errorAlert('Falha na operação!', 5000, 'remove_ativo')
      }
    }
    setAtivos(filtro)
  }

  const listCatProduto = async () => {
    const resp: AxiosResponse<TypeCategoriaProdutos> = await getCategoriaProdutos({ codGrupo: 20 })

    setDataCatProduto(resp.data.itens)
  }

  async function listCatInsumos() {
    const resp: AxiosResponse = await getCategoriaInsumo({})

    setDataCatCategoria(resp.data.itens)
  }

  const listFabricantes = async () => {
    const resp = await getCategoriaMarcaInsumo()
    setDataFabricantes(resp.data.itens)
  }

  const listFormulacao = async () => {
    const resp: AxiosResponse<TypeFormulacao> = await getFormulacao({
      pagination: -1,
    })

    setDataFormulacao(resp.data.itens)
  }

  const listUnidadeMedida = async () => {
    const resp = await listMedidas()

    setDataUnidadeMedida(resp)
  }

  useEffect(() => {
    if (update > 0) {
      editInsumo(update)
    }
  }, [update])

  useEffect(() => {
    if (clone > 0) {
      editInsumo(clone)
    }
  }, [clone])

  useEffect(() => {
    listCatProduto()
    listCatInsumos()
    listFabricantes()
    listFormulacao()
    listUnidadeMedida()
  }, [])

  useEffect(() => {
    setLoadingTable(true)
    listInsumos()
  }, [])

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        listInsumos()
      }, 700)
    }
    if (buscarTabela === '') {
      listInsumos()
    }
  }, [buscarTabela])

  useEffect(() => {
    listInsumos()
  }, [page])

  useEffect(() => {
    listInsumos()
  }, [pagination])

  return (
    <ContainerInsumos>
      <ViewPage
        title='Catálogo insumos'
        onPermission={setPermissions}
        rotina={38}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
        newHide
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Catálogo insumos</TitleH1>
        </div>
        <TabelaInsumos
          loading={loadingTable}
          list_insumos={dataInsumos}
          permissions={permissions}
          deletar={deletarInsumo}
          abrir={abrir}
          editar={handleClickEdit}
          clone={handleClickClone}
          page={page}
          setPage={setPage}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          setPagination={setPagination}
          total={total}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
        />

        <Drawer
          width={800}
          open={visibleForm}
          onClose={fecharGaveta}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
          destroyOnClose
          footer={
            <div className='footer'>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                type='primary'
                onClick={salvarInsumos}
                // loading={loadingSalvar}
                // disabled={loadingSalvar}
              >
                Salvar
              </ButtonCustom>
            </div>
          }
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={fecharGaveta}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
        >
          <FormInsumoNovo
            update={update}
            criadoPorAtualizadoPor={''}
            loadingForm={loadingForm}
            tab_selecionar_atual={tab_selecionar_atual}
            setTab_selecionar_atual={setTab_selecionar_atual}
            permissions={permissions}
            nome={nome}
            setNome={setNome}
            categoria_insumo={categoria}
            setCategoria_insumo={setCategoria}
            categoria_insumoId={categoriaId}
            setCategoria_insumoId={setCategoriaId}
            classeAgro={classeAgro}
            setClasseAgro={setClasseAgro}
            classeAgroId={classeAgroId}
            setClasseAgroId={setClasseAgroId}
            fabricante={fabricante}
            setFabricante={setFabricante}
            fabricanteId={fabricanteId}
            setFabricanteId={setFabricanteId}
            formulacao={formulacao}
            setFormulacao={setFormulacao}
            formulacaoId={formulacaoId}
            setFormulacaoId={setFormulacaoId}
            unidadeDose={unidadeDose}
            setUnidadeDose={setUnidadeDose}
            unidadeDoseId={unidadeDoseId}
            setUnidadeDoseId={setUnidadeDoseId}
            observacao={observacao}
            setObservacao={setObservacao}
            ativo={ativo}
            setAtivo={setAtivo}
            ativos={ativos}
            setAtivos={setAtivos}
            ativosId={ativosId}
            setAtivoId={setAtivosId}
            concentracao={concentracao}
            setConcentracao={setConcentracao}
            cultura={cultura}
            setCultura={setCultura}
            culturaId={culturaId}
            setCulturaId={setCulturaId}
            faseDeCultura={faseDeCultura}
            setFaseDeCultura={setFaseDeCultura}
            faseDeCulturaId={faseDeCulturaId}
            setFaseDeCulturaId={setFaseDeCulturaId}
            aplicacoes={aplicacoes}
            setAplicacoes={setAplicacoes}
            especieNome={especie}
            setEspecieNome={setEspecie}
            especieId={especieId}
            setEspecieId={setEspecieId}
            variacaoEspecie={variacaoEspecie}
            setVariacaoEspecie={setVariacaoEspecie}
            variacaoEspecieId={variacaoEspecieId}
            setVariacaoEspecieId={setVariacaoEspecieId}
            doseBula={doseBula}
            setDoseBula={setDoseBula}
            doseUsual={doseUsual}
            setDoseUsual={setDoseUsual}
            alvoSelect={alvoSelect}
            setAlvoSelect={setAlvoSelect}
            codClone={clone}
            dataCatProduto={dataCatProduto}
            dataCatCategoria={dataCatCategoria}
            dataFabricantes={dataFabricantes}
            dataFormulacao={dataFormulacao}
            dataUnidadeMedida={dataUnidadeMedida}
            handleChangeClasse={handleChangeClasse}
            dataAtivos={dataAtivos}
            doseBulaUpdate={doseBulaUpdate}
            setDoseBulaUpdate={setDoseBulaUpdate}
            doseUsualUpdate={doseUsualUpdate}
            setDoseUsualUpdate={setDoseUsualUpdate}
            adicionarAtivos={adicionarAtivos}
            updateAlvo={updateAlvo}
            handleRemoveAtivo={handleRemoveAtivo}
            removeAlvo={removeAlvo}
          />
        </Drawer>
      </ViewPage>
    </ContainerInsumos>
  )
}

export default CatalogoDefensivos
